// Imports
import Axios from '@/config/AxiosConfig';
import { getModPermissionsData } from '@/api/UserServices';
// import { usepropertyModStore } from "@/stores/propertyModStore";

// const propertyModStore = usepropertyModStore();

// Get Properties
export const getPropertyList = async (id) => {
    const url = `/property/get-properties/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Board Data
// export const getPropertyBoardData = async (boardId) => {
//     const url = `/property/board/data/${boardId}`;
//
//     try {
//         const { data } = await Axios.get(url);
//         return data;
//     } catch (e) {
//         return e.response;
//     }
// };

// Get Contact Form Fields
export const getPropertyFormFields = async (id) => {
    const url = `/property/field/get-fields/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get Properties country Format
export const getAddressFormat = async (country) => {
    const url = `contact/get-address/${country}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Properties Autocomplete
export const autocomplete = async (term) => {
    const url = `auto-complete/${term}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const GetPostcodes = async (term) => {
    const url = `auto-complete-postcode/${term}/postcode`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Autocomplete details
export const getAutocompleteDetails = async (id) => {
    const url = `get-address-details/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Filters
export const getPropertyFilters = async (id) => {
    const url = `/property/get-filters/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Filters
export const updatePropertyFilters = async (payload) => {
    const url = `/property/update-filter`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Add Tenancy
export const addTenancy = async (payload) => {
    const url = `/tenancy/add-tenancy`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateTenancy = async (payload) => {
    const url = `/tenancy/update-tenancy`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addSale = async (payload) => {
    const url = `/sale/create-sale`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateSale = async (payload) => {
    const url = `/sale/update-sale`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Sale Section Field
export const getSaleSectionField = async (sectionId) => {
    const url = `sale/field/get-section/${sectionId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Sale field
export const getSalesField = async (fieldId) => {
    const url = `sale/fields/get-field/${fieldId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const tenancyTerminateDate = async (payload) => {
    const url = `tenancy/get-terminate-date/${payload.tenancy_id}?date=${payload.date}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const setTenancyTerminate = async (payload) => {
    const url = `tenancy/set-terminate-date`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const executeTenancy = async (payload) => {
    const url = `tenancy/change-status/${payload}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getTenancy = async (payload) => {
    const url = `/tenancy/get-property-tenancy/p/${payload}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getSaleandEditSales = async (type, id) => {
    const url = `/sale/get-property-sales/${type}/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getSingleTenancy = async (payload) => {
    const url = `/tenancy/get-property-tenancy/o/${payload}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getSingleSale = async (payload) => {
    const url = `/tenancy/get-property-tenancy/o/${payload}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Contact
export const addProperty = async (payload) => {
    const url = '/property/add';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Contact
export const saleWithdrawExchangeComplete = async (payload) => {
    const url = '/sale/sales-action';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// update Contact
export const updateProperty = async (payload) => {
    const url = '/property/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Form Fields
export const getPropertyTypeLabels = async (contactType) => {
    const url = `/property/label/get/${contactType}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Board Step
export const updatePropertyBoardStep = async (propertyId, stepId) => {
    const url = `property/change-property-step/${propertyId}/${stepId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// Get property logs
export const getPropertyLogs = async (propertyId, tabName = '') => {
    const url =
        `timeline/get-timelines?property_id=${propertyId}` +
        (tabName ? `&tab=${tabName}` : '');
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Contact Group Labels
export const updatePropertyLabels = async (payload) => {
    const url = `property/change-property-labels`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Contact Group
export const getProperty = async (id) => {
    const url = `/property/get/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get property details
export const getPropertyDetails = async (id) => {
    const url = `/property/details/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort property Group
export const sortProperty = async (payload) => {
    const url = 'property/sort';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Delete Contact Group
export const deleteProperty = async (id) => {
    const url = `/property/delete/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Delete Contact Group
export const bulkDeleteProperty = async (id, payload) => {
    const url = `/property/bulk/delete/${id}`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Archive Contact Group
export const archiveProperty = async (id) => {
    const url = `/property/archive/` + id;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Assign Label Contact Group
export const bulkAssignLabelProperty = async (id, payload) => {
    const url = `/property/bulk/reassign-label`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Archive Contact Group
export const bulkArchiveProperty = async (id, payload) => {
    // const url = `/property/bulk/archive/${id}`;
    const url = `/property/bulk/archive/` + id;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Bulk Re-assign property Group
export const bulkReassignProperty = async (id, payload) => {
    // const url = `/property/bulk/reassign-user/${id}`;
    const url = `/property/bulk/reassign-user`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updatePropertyTypeLabels = async (payload) => {
    const url = `/property/label/update`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updatepropertyModData = async () => {
    try {
        const response = await getModPermissionsData('properties');
        console.log(response,'properties response');
        return response;
    } catch (e) {
        console.log(e);
    }
};

// Get Property Categories
export const getPropertyCategories = async () => {
    const url = `/property/category/getList`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getPropertySales = async () => {
    const url = `/sale/fields/list`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Property Category
export const getPropertyCategory = async (id) => {
    const url = `/property/category/getList/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Add Property Category
export const addPropertyCategory = async (payload) => {
    const url = '/property/category/add';
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Property Category
export const updatePropertyCategory = async (payload) => {
    const url = '/property/category/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Property Category Status
export const updatePropertyCategoryStatus = async (id, status) => {
    const url = `/property/category/change-status/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Property sale Status
export const updatePropertySaleSectionStatus = async (id, status) => {
    const url = `/sale/fields/change-section-status/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Update Property sale Status
export const updatePropertySaleFieldsStatus = async (id, status) => {
    const url = `sale/fields/change-field-status/${id}/${status}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort Property Categories
export const sortPropertyCategories = async (payload) => {
    const url = '/property/category/sort-property-category';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort Section
export const sortSaleSection = async (payload) => {
    const url = 'sale/fields/sort-section';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Sort Property Sale
export const sortPropertySale = async (payload) => {
    const url = '/sale/fields/sort-field';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addPropertyFeed = async (payload) => {
    const url = '/property/portal/property-feed-status';
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// Get Property Category
export const getEpcPreview = async (epc) => {
    const url = `/property/real-time-epc/${epc.current}/${epc.potential}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const getChatGptDescription = async (payload) => {
    const url = `/property/get-data-from-gpt`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
// export const checkBeforePublish = async (payload) => {
//     const url = "/property/portal/property-feed-status";
//     try {
//         const { data } = await Axios.post(url, payload);
//         return data;
//     } catch (e) {
//         return e.response;
//     }
// };

export const updateMissingFieldsData = async (payload) => {
    const url = '/property/update-property-missing-fields';
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// GetMatching Contacts Groups
export const GetMatchingContactGroups = async (payload) => {
    const url = `/contact/alert/get-matching-contact-groups/${payload.property_id}?page_no=${payload.page_no}&pf_branches=${payload.pf_branches || ''}&pf_labels=${payload.pf_labels || ''}&pf_users=${payload.pf_users || ''}&active=${payload.active || ''}&sort_by=${payload.sort_by || ''}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// GetMatching Contacts veiwings
export const GetMatchingViewing = async (property_id, page_no) => {
    const url = `/contact/alert/get-property-viewings/${property_id}?page_no=${page_no}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const GetFilter = async (payload) => {
    const url = `/contact/alert/get-contact_groups-filters/${payload.property_id}`;
    try {
        const { data } = await Axios.get(url, payload);
        return data;
    } catch {
        return e.response;
    }
};

export const addSalePropertyField = async (payload) => {
    const url = 'sale/fields/add';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateSalePropertyField = async (payload) => {
    const url = 'sale/fields/update';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const UpdateContactsFilter = async (payload) => {
    const url = '/contact/alert/update-contact_groups-filter';
    try {
        const data = await Axios.post(url, payload);
    } catch (e) {
        return e.response;
    }
};

export const UpdatePropertyFeeField = async (payload) => {
    const url = '/property/update-property-fee';
    try {
        const data = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const MissingPropertyData = async (id) => {
    const url = `/property/evaluation-report-missing-data/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getSalesFields = async () => {
    const url = `/sale/fields/get-all`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateSalesChecklist = async (payload) => {
    const url = `/sale/update-sale-checklist`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getTenancyFields = async () => {
    const url = `/tenancy/field/get-fields`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateMissingData = async (payload) => {
    const url = `/property/update-property-missing-fields`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const GetValuationReport = async (id, diary_id, template_id) => {
    const url = `/valuation-report/${id}/${diary_id}/${template_id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const GetValuationReportSmartTag = async (id) => {
    const url = `/valuation-report-smart_tags/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const ValuationReportDropDown = async (id) => {
    const url = `/valuation-report-dropdown/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// render sales documents
export const renderSaleDocs = async (payload) => {
    const url = `sale/render-sale-document`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// add sales documents
export const addSaleDocs = async (payload) => {
    const url = `sale/add-sale-document`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// add sales documents
export const saveTenancyTemplate = async (payload) => {
    const url = `tenancy/save-tenancy-document`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// render tenancy documents
export const renderTenancyDocs = async (tenancyId, tempId) => {
    const url = `tenancy/generate-tenancy-document/${tempId}/${tenancyId}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

//  Create Offer
export const createOffer = async (payload) => {
    const url = '/offer/create-offer';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addCounterOffer = async (payload) => {
    const url = '/offer/add-counter-offer';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const shareOffer = async (payload) => {
    const url = '/offer/share-offer';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};



export const updateCounterOffer = async (payload) => {
    const url = '/offer/update-counter-offer';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const OfferAction = async (payload) => {
    const url = '/offer/offer-action';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getOffer = async (type, id) => {
    const url = `offer/get-offer/${type}/${id}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getOfferLetter = async (counterOfferId, letterId) => {
    const url = `offer/get-offer-letter/${counterOfferId}/${letterId}`;

    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const saveOfferLetter = async (payload) => {
    const url = `offer/add-offer-letter`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const offerSharewithVendor = async (payload) => {
    const url = `offer/is-send`;

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getPropertyContacts = async (propertyId) => {
    const url = `/property/contact-uuid/${propertyId}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}

export const getPropertyBoards = async (contactTypeId) => {
    const url = `/property/get-property-board-steps/${contactTypeId}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}

